import EnhancedPostContentManager from './enhancedPostContentManager/EnhancedPostContentManager';

export default EnhancedPostContentManager;